import { Popover } from "@/design-system/Popover/Popover";
import { cn } from "@/lib/utils";
import { Info } from "lucide-react";

/** An info icon (or `icon`, which can be a whole tile) that opens `children` in a popover on click. */
export const InfoTip = ({
  label,
  width,
  icon = <Info className="size-3.5" />,
  className,
  children,
}: {
  /** The trigger's accessible name; needed when `icon` has no text of its own. */
  label?: string;
  width?: number;
  icon?: React.ReactNode;
  /** The trigger's classes, e.g. its colours. */
  className?: string;
  children: React.ReactNode;
}) => (
  <Popover
    width={width}
    negLabel=""
    posLabel=""
    trigger={
      <button
        type="button"
        aria-label={label}
        className={cn(
          "flex shrink-0 text-foreground-muted hover:text-foreground",
          className,
        )}
      >
        {icon}
      </button>
    }
  >
    <div className="text-sm text-foreground-body">
      {/* Keeps the popover's pinned close button clear; the text wraps around it. */}
      <span aria-hidden className="float-right ml-2 h-[30px] w-[26px]" />
      {children}
    </div>
  </Popover>
);
